<template>
  <div class="centers-region-buttons neumorphism-in">
    <RegionButton
      v-for="[k, i] in regions"
      v-if="i.centers.length > 0"
      :key="i.id"
      :region="i"
      :isSelected="selectedRegion != undefined && selectedRegion.id == i.id"
      @click="onClick"
      @mouseover="onMouseOver(i)"
      @mouseleave="onMouseLeave(i)"
    />
  </div>
</template>

<script>
import RegionButton from "@/components/components-salles/public/center/map-overview/RegionButton";

export default {
  name: "RegionButtons",
  components: {
    RegionButton,
  },
  props: {
    regions: null,
    selectedRegion: null,
  },
  methods: {
    /**
     * Notifies the parent component that a click occurred on a button
     * and transmits its associated region
     */
    onClick(region) {
      this.$emit("click", region);
    },
    onMouseOver(region) {
      this.$emit("mouseover", region);
    },
    onMouseLeave(region) {
      this.$emit("mouseleave", region);
    },
  },
};
</script>

<style lang="scss" scoped>
.centers-region-buttons {
  padding: 10px 10px;
  border-radius: 30px;
  display: inline;
  flex-wrap: wrap;
  border: solid 1px var(--border-color);

  button:last-child {
    margin-right: 0px;
  }
}
</style>
